import React from 'react'

const Funding = () => {
  return (
    <div>Funding</div>
  )
}

export default Funding